export const TITLE = "Euler HiLoad ev 130 Price in 2026 - Range, Specification & Reviews | Turno";

export const META_CONTENT = [
  {
    name: "description",
    content:
      "Looking for Euler HiLoad EV 130 Cubic Feet price, range, load capacity, and specifications? Get all the details on this electric commercial vehicle and more at Turno for 2026.",
  },
  {
    name: "keywords",
    content:
      "Euler HiLoad EV 130 Cubic Feet 3 Wheeler, Euler HiLoad, Euler electric vehicle, Euler electric cargo vehicle, Euler electric commercial vehicle, Euler HiLoad price, Euler HiLoad specifications, Euler HiLoad range, Euler HiLoad load capacity, Euler electric vehicle price, Euler commercial vehicle, Euler electric auto, Euler EV, Euler electric truck, Euler cargo vehicle, Euler electric vehicle specifications, Euler electric vehicle features, Euler electric vehicle reviews, Euler electric vehicle dealer, Euler HiLoad DV",
  },
  {
    name: "author",
    content: "Turno",
  },
  {
    name: "url",
    content:
      "https://www.turno.club/electric-commercial-vehicles/Euler/HiLoadDV",
  },
  {
    name: "robots",
    content: "INDEX,ARCHIVE,FOLLOW",
  },
  {
    name: "lang",
    content: "en",
  },
  {
    name: "viewport",
    content: "width=device-width, initial-scale=1",
  },
  {
    property: "og:url",
    content:
      "https://www.turno.club/electric-commercial-vehicles/Euler/HiLoadDV",
  },
  {
    property: "og:type",
    content: "website",
  },
  {
    property: "og:title",
    content: "Euler HiLoad ev 130 Price in 2026 - Range, Specification & Reviews | Turno",
  },
  {
    property: "og:description",
    content:
      "Looking for Euler HiLoad EV 130 Cubic Feet price, range, load capacity, and specifications? Get all the details on this electric commercial vehicle and more at Turno for 2026.",
  },
  {
    property: "og:image",
    content: "/logoIcon.png",
  },
  {
    property: "fb:app_id",
    content: "5796260583761767",
  },
  {
    property: "fb:pages",
    content: "646488286564232",
  },
  {
    name: "twitter:description",
    content:
      "Looking for Euler HiLoad EV 130 Cubic Feet price, range, load capacity, and specifications? Get all the details on this electric commercial vehicle and more at Turno for 2026.",
  },
  {
    name: "twitter:title",
    content: "Euler HiLoad ev 130 Price in 2026 - Range, Specification & Reviews | Turno",
  },
  {
    name: "twitter:site",
    content: "@Turno",
  },
  {
    name: "twitter:creator",
    content: "@Turno",
  },
  {
    name: "twitter:url",
    content:
      "https://www.turno.club/electric-commercial-vehicles/Euler/HiLoadDV",
  },
  {
    name: "twitter:app:id:googleplay",
    content: "com.customerapp.turno.turno_customer_application",
  },
  {
    name: "twitter:app:country",
    content: "IN",
  },
];

export const VEHICLE_LINK =
  "https://www.turno.club/electric-commercial-vehicles/Euler/HiLoadDV";

export const HIGHLIGHTS_HEADING = "Product Highlights";

export const SUB_TEXT =
  "Introducing the Euler HiLoad electric auto, a true game-changer for cargo transportation. This exceptional three-wheeler electric tempo offers unmatched performance, stability, and an impressive load-carrying capacity of 688 kg, making it the perfect choice for businesses. With 88.55 Nm of torque, a 10.96 kWh motor, and a top speed, it ensures efficient and reliable deliveries. Let's delve into the key features and advantages of the Euler HiLoad:";

export const MOSTLY_BOUGHT_FOR_HEADING = "Mostly bought for";

export const BUSINESS_BENEFIT_HEADING =
  "Business Benefit with Electric Vehicle";

export const FEATURES_HEADING = "Features of Euler HiLoad";

export const BRAND_DEALER_HEADING = "Euler HiLoad Dealers Near Me: ";

export const BRAND_DEALER_DESCRIPITION =
  "As Euler's influence continues to expand throughout India, Turno is thrilled to introduce the outstanding Euler HiLoad electric auto. With a growing community of individuals and businesses turning to Euler electric trucks for their transportation needs, renowned for its commitment to affordability and quality, we are your trusted partner in bringing the Euler HiLoad to your doorstep.";

export const FAQ_HEADING_TEXT = "FAQs on Euler HiLoad";

export const BREADCRUMB_ITEMS = [
  { label: "Home", href: "/" },
  { label: "Electric Commercial Vehicles", href: "/electric-commercial-vehicles" },
  { label: "Euler", href: "/electric-commercial-vehicles/Euler" },
  { label: "HiLoad DV" },
];

export const BREADCRUMB_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    {
      "@type": "ListItem",
      position: 1,
      name: "Home",
      item: "https://www.turno.club/",
    },
    {
      "@type": "ListItem",
      position: 2,
      name: "Electric Commercial Vehicles",
      item: "https://www.turno.club/electric-commercial-vehicles",
    },
    {
      "@type": "ListItem",
      position: 3,
      name: "Euler",
      item: "https://www.turno.club/electric-commercial-vehicles/Euler",
    },
    {
      "@type": "ListItem",
      position: 4,
      name: "HiLoad DV",
      item: VEHICLE_LINK,
    },
  ],
};
